import { render, staticRenderFns } from "./OrdersDashboard.vue?vue&type=template&id=721a7aff&scoped=true&"
import script from "./OrdersDashboard.vue?vue&type=script&lang=js&"
export * from "./OrdersDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OrdersDashboard.vue?vue&type=style&index=0&id=721a7aff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721a7aff",
  null
  
)

export default component.exports